"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _accounts = _interopRequireDefault(require("./accounts"));

var _addresses = _interopRequireDefault(require("./addresses"));

// Copyright 2017-2019 @polkadot/ui-keyring authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
var _default = (0, _rxjs.combineLatest)(_accounts.default.subject, _addresses.default.subject).pipe((0, _operators.map)((_ref) => {
  let _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      accounts = _ref2[0],
      addresses = _ref2[1];

  return {
    accounts,
    addresses
  };
}));

exports.default = _default;